const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const resolveVideoUrl = (url) => (url && url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url);

const ytId = (url) => {
  const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
  return m ? m[1] : null;
};
const vimeoId = (url) => { const m = url.match(/vimeo\.com\/(\d+)/); return m ? m[1] : null; };

export const VideoPlayer = ({ video, className = "", testId }) => {
  const yt = ytId(video.url);
  const vm = vimeoId(video.url);
  const frame = "w-full h-full";
  if (yt) return <iframe title={video.title} src={`https://www.youtube-nocookie.com/embed/${yt}`} className={`${frame} ${className}`} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-testid={testId} />;
  if (vm) return <iframe title={video.title} src={`https://player.vimeo.com/video/${vm}`} className={`${frame} ${className}`} allow="autoplay; fullscreen; picture-in-picture" allowFullScreen data-testid={testId} />;
  return <video src={resolveVideoUrl(video.url)} poster={video.poster || undefined} controls playsInline preload="metadata" className={`${frame} object-contain bg-black ${className}`} data-testid={testId} />;
};
